import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from './api/axiosInstance';
import Modal from 'react-bootstrap/Modal';
import base_url from './api/Config';
import TopBar from './component/TopBar';

function Approvedloan() {
  const [loanDetails, setLoanDetails] = useState(null);
  const [showEsign, setShowEsign] = useState(false);
  const [showAutodebit, setShowAutodebit] = useState(false);
  const [showKFS, setShowKFS] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const applicationId = params.get('applicationId') || params.get('id');
  const customerId = params.get('customerId') || applicationId;

  useEffect(() => {
    if (!applicationId) return;
    api.get(`${base_url}/api/userProduct/application`, { params: { id: applicationId } })
      .then(res => setLoanDetails(res.data))
      .catch(() => {});
  }, [applicationId]);

  const infoRows = loanDetails ? [
    { label: 'Loan Amount',     value: `₹${loanDetails.loanAmount} /-` },
    { label: 'Tenure',          value: `${loanDetails.tenure} Days` },
    { label: 'ROI',             value: `${loanDetails.intRate}%` },
    { label: 'Processing Fee',  value: `₹${loanDetails.processFee} /-` },
    { label: 'APR',             value: `${loanDetails.apr}%` },
    { label: 'Repayment',       value: `₹${loanDetails.emiAmount} /-` },
    { label: 'Disbursed Amount',value: `₹${loanDetails.disbursementAmount} /-` },
    { label: 'Instalments',     value: loanDetails.noOfInstalment },
  ] : [];

  return (
    <div className="app-page">
      <TopBar title="Your Approved Loan" backPath={`/CreditCheck?applicationId=${applicationId}&customerId=${customerId}`} />

      <div className="app-content">
        <div className="app-card">
          <p className="section-title">Loan Summary</p>
          {!loanDetails ? (
            <p style={{ color: '#888', textAlign: 'center' }}>Loading...</p>
          ) : (
            infoRows.map((row, i) => (
              <div key={i} className="info-row">
                <span>{row.label}</span>
                <strong>{row.value}</strong>
              </div>
            ))
          )}
          <div
            style={{ textAlign: 'center', marginTop: 12, fontSize: 13, color: '#1d2e77', fontWeight: 600, cursor: 'pointer' }}
            onClick={() => setShowKFS(true)}
          >
            View Key Fact Statement (KFS)
          </div>
        </div>

        <div className="app-card">
          <p className="section-title">Know More</p>
          <div
            className="list-card"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowEsign(true)}
          >
            <span style={{ fontWeight: 600, fontSize: 14 }}>Why we do E-Sign?</span>
            <span style={{ color: '#1d2e77', fontSize: 13 }}>Learn more</span>
          </div>
          <div
            className="list-card"
            style={{ cursor: 'pointer', marginTop: 8 }}
            onClick={() => setShowAutodebit(true)}
          >
            <span style={{ fontWeight: 600, fontSize: 14 }}>Why we do Auto-Debit?</span>
            <span style={{ color: '#1d2e77', fontSize: 13 }}>Learn more</span>
          </div>
        </div>

        <button
          className="btn-primary-app"
          onClick={() => navigate(`/Employmentdetails?applicationId=${applicationId}&customerId=${customerId}`)}
        >
          Proceed
        </button>
      </div>

      <Modal show={showEsign} onHide={() => setShowEsign(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>About E-Sign</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: 14, color: '#444', lineHeight: 1.6 }}>
            E-signing streamlines the signing process, enhances security, ensures authenticity,
            provides a legal record of consent, and facilitates quicker transactions without
            the need for physical paperwork.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setShowEsign(false)}>Okay</button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAutodebit} onHide={() => setShowAutodebit(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>About Auto-Debit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: 14, color: '#444', lineHeight: 1.6 }}>
            Auto debit ensures timely payments, reduces the risk of missed or late payments,
            simplifies the billing process, enhances cash flow management, and provides
            convenience by automating recurring EMI transactions.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setShowAutodebit(false)}>Okay</button>
        </Modal.Footer>
      </Modal>

      <Modal show={showKFS} onHide={() => setShowKFS(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Key Fact Statement</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <p style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
            Dear {loanDetails?.name || 'Borrower'},
          </p>
          {loanDetails && (
            <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
              <tbody>
                {[
                  ['Loan Term', `${loanDetails.tenure} Days`],
                  ['Loan Amount', `₹${loanDetails.loanAmount}`],
                  ['Processing Fee', `₹${loanDetails.processFee}`],
                  ['Net Disbursed Amount', `₹${loanDetails.disbursementAmount}`],
                  ['Interest Amount', `₹${loanDetails.interestAmount}`],
                  ['APR', `${loanDetails.apr}%`],
                  ['No. of Instalments', loanDetails.noOfInstalment],
                  ['Lock-in Period', '3 Days'],
                  ['Prepayment Charges', '1% of principal or ₹250, whichever is higher'],
                  ['Late Payment Charges', '₹300 flat + 36% p.a. on overdue amount (GST applicable)'],
                  ['Lender', 'Ujjawal Srijan'],
                ].map(([label, value], i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '6px 4px', color: '#666' }}>{label}</td>
                    <td style={{ padding: '6px 4px', fontWeight: 600, textAlign: 'right' }}>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <p style={{ fontSize: 11, color: '#999', marginTop: 16 }}>
            Cooling-off Period: You may prepay within 3 days from availing the loan by paying
            the principal and proportionate APR without any prepayment penalty.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setShowKFS(false)}>Okay</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Approvedloan;
